import React from "react"
import { Navigate } from "react-router-dom"

// Dashboard
import MarketingDashboard from "../pages/Dashboard/Marketing/index"

//Pages
import PagesStarter from "../pages/Utility/pages-starter"
import PagesMaintenance from "../pages/Utility/pages-maintenance"
import PagesComingsoon from "../pages/Utility/pages-comingsoon"
import Pages404 from "../pages/Utility/pages-404"
import Pages500 from "../pages/Utility/pages-500"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"

// Test
import Category from "../pages/Category"

//Own Pages
const userRoutes = [
  //dahshboard
  { path: "/dashboard", component: <MarketingDashboard /> },
  {
    path: "/social-dashboard",
    component: <MarketingDashboard name="Social" />,
  },
  { path: "/hrms-dashboard", component: <MarketingDashboard name="HRMS" /> },
  {
    path: "/accounts-dashboard",
    component: <MarketingDashboard name="Accounts" />,
  },
  {
    path: "/feedback-dashboard",
    component: <MarketingDashboard name="Feedback" />,
  },
  //Utility
  { path: "/pages", component: <PagesStarter /> },

  { path: "/category", component: <Category /> },

  // Test

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to={sessionStorage.getItem("module_url")} />,
  },
  {
    path: "*",
    component: <Navigate to={sessionStorage.getItem("module_url")} />,
  },
]

const authRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },

  { path: "/pages-maintenance", component: <PagesMaintenance /> },
  { path: "/pages-comingsoon", component: <PagesComingsoon /> },
  { path: "/pages-404", component: <Pages404 /> },
  { path: "/pages-500", component: <Pages500 /> },
]

export { userRoutes, authRoutes }
